export default __webpack_public_path__ + "static/media/technology.73c1f6db.png";